// Mock data for The Hidden Garden EMS website

export const testimonials = [
  {
    id: 1,
    name: "Sophie L.",
    location: "Oullins",
    rating: 5,
    text: "Incroyable transformation en 3 mois ! L'EMS combiné aux soins esthétiques a complètement redessiné ma silhouette. L'ambiance du centre est apaisante et le suivi personnalisé.",
    service: "EMS + Vaccum Thérapie"
  },
  {
    id: 2,
    name: "Marie D.",
    location: "Lyon Sud",
    rating: 5,
    text: "Enfin un centre qui combine expertise et ambiance premium. Les séances EMS de 25 min s'adaptent parfaitement à mon emploi du temps chargé. Résultats visibles dès le 2ème mois !",
    service: "Abonnement 8 séances/mois"
  },
  {
    id: 3,
    name: "Camille R.",
    location: "Oullins",
    rating: 5,
    text: "Le traitement Perfect Stril a considérablement amélioré l'apparence de mes vergetures. L'équipe est à l'écoute et professionnelle. Je recommande vivement !",
    service: "Perfect Stril"
  },
  {
    id: 4,
    name: "Laura M.",
    location: "Pierre-Bénite",
    rating: 5,
    text: "Après 2 grossesses, je pensais ne jamais retrouver ma silhouette. Grâce au programme EMS Zéro RF et à l'accompagnement bienveillant de l'équipe, j'ai retrouvé confiance en moi. Merci infiniment !",
    service: "EMS Zéro RF"
  },
  {
    id: 5,
    name: "Julie B.",
    location: "Lyon 7ème",
    rating: 5,
    text: "Le cadre est magnifique, avec toutes ces plantes c'est vraiment relaxant. Les résultats de la radiofréquence sur ma peau sont incroyables, elle est beaucoup plus ferme. Je me sens rajeunie !",
    service: "Radiofréquence"
  },
  {
    id: 6,
    name: "Émilie T.",
    location: "Oullins",
    rating: 5,
    text: "J'avais des zones de cellulite très installées. Après 10 séances de Vaccum thérapie, la différence est flagrante ! Ma peau est plus lisse et tonique. Je continue pour optimiser les résultats.",
    service: "Vaccum Thérapie"
  },
  {
    id: 7,
    name: "Anaïs P.",
    location: "Lyon Sud",
    rating: 5,
    text: "Les 200 000 contractions par séance, ça change vraiment tout ! Je vois mes abdos se dessiner et mes fessiers se galber. Et tout ça en seulement 25 minutes, c'est juste génial !",
    service: "EMS Zéro RF"
  },
  {
    id: 8,
    name: "Charlotte K.",
    location: "Irigny",
    rating: 5,
    text: "Le drainage lymphatique m'a aidée à éliminer ma rétention d'eau. Je me sens tellement plus légère ! L'ambiance zen du centre est un vrai plus pour se détendre.",
    service: "Drainage Lymphatique"
  },
  {
    id: 9,
    name: "Sabrina H.",
    location: "Oullins",
    rating: 5,
    text: "Programme complet EMS + soins pendant 4 mois. Résultats au-delà de mes espérances ! J'ai perdu du volume là où il fallait et gagné en tonicité. Le centre est à 5 min de chez moi, pratique !",
    service: "Programme Complet"
  },
  {
    id: 10,
    name: "Aurélie F.",
    location: "Lyon Sud",
    rating: 5,
    text: "Coach ultra professionnelle et à l'écoute. Chaque séance est adaptée à ma progression. L'espace privé permet de se concentrer pleinement. C'est mon moment bien-être de la semaine !",
    service: "Abonnement 4 séances/mois"
  },
  {
    id: 11,
    name: "Nadia Z.",
    location: "Saint-Genis-Laval",
    rating: 5,
    text: "La lipocavitation a ciblé mes poignées d'amour récalcitrantes. Couplée à l'EMS, les résultats sont spectaculaires. Je rentre à nouveau dans mes jeans préférés !",
    service: "Lipocavitation + EMS"
  },
  {
    id: 12,
    name: "Jessica M.",
    location: "Oullins",
    rating: 5,
    text: "Centre vraiment haut de gamme avec un excellent rapport qualité-prix. L'ambiance jardin tropical est tellement apaisante. Je ressors de chaque séance détendue et motivée. Bravo !",
    service: "Abonnement 8 séances/mois"
  }
];

export const faqData = [
  {
    question: "L'EMS est-il vraiment efficace pour sculpter la silhouette ?",
    answer: "Oui ! L'électrostimulation musculaire (EMS) active jusqu'à 90% des fibres musculaires simultanément, contre 30% lors d'un entraînement classique. Une séance de 25 minutes équivaut à plusieurs heures de sport traditionnel. Combiné à un suivi personnalisé, l'EMS permet un remodelage visible et durable de la silhouette."
  },
  {
    question: "À partir de quel âge peut-on bénéficier des soins esthétiques ?",
    answer: "Nos soins sont adaptés aux adultes à partir de 18 ans. Chaque programme est personnalisé selon votre âge, votre morphologie et vos objectifs. Lors du bilan initial, nous évaluons vos besoins spécifiques pour créer un parcours sur-mesure."
  },
  {
    question: "Combien de séances sont nécessaires pour voir des résultats ?",
    answer: "Les premiers résultats sont généralement visibles dès 4 à 6 séances pour l'EMS. Pour des résultats optimaux et durables, nous recommandons un programme de 3 à 6 mois avec 4 à 8 séances mensuelles. Chaque corps réagit différemment, c'est pourquoi nous adaptons le suivi."
  },
  {
    question: "Les séances EMS sont-elles douloureuses ?",
    answer: "Non, les séances ne sont pas douloureuses. Vous ressentirez des contractions musculaires contrôlées et l'intensité est ajustée selon votre confort et votre progression. La plupart de nos clients trouvent les séances agréables et énergisantes."
  },
  {
    question: "Puis-je combiner plusieurs soins esthétiques ?",
    answer: "Absolument ! Nous recommandons même de combiner EMS et soins esthétiques pour des résultats optimaux. Par exemple, l'EMS renforce les muscles tandis que la Vaccum thérapie traite la cellulite. Lors de votre bilan personnalisé, nous élaborons le protocole le plus adapté à vos objectifs."
  },
  {
    question: "Quelle est la différence entre l'abonnement avec et sans engagement ?",
    answer: "L'abonnement avec engagement de 6 mois (renouvelable) offre des tarifs avantageux : 135€ pour 4 séances ou 200€ pour 8 séances par mois. Sans engagement, les tarifs sont de 155€ et 280€ respectivement. L'engagement vous garantit un suivi régulier optimal pour des résultats durables."
  }
];

export const services = {
  ems: [
    {
      name: "EMS Zéro",
      description: "Électrostimulation complète du corps pour renforcement musculaire global",
      duration: "25 min",
      benefits: ["Renforcement musculaire profond", "Ventre plus ferme", "Fessiers galbés", "Bien-être général"]
    }
  ],
  aesthetic: [
    {
      name: "EMS Zéro Radiofréquence",
      description: "Perte de volume localisé avec 200 000 contractions en 30 minutes",
      benefits: ["200 000 contractions musculaires", "Raffermissement cutané par radiofréquence", "Perte de volume ciblée", "Résultats visibles rapidement"]
    },
    {
      name: "Perfect Stril",
      description: "Traitement avancé des vergetures",
      benefits: ["Réduction visible des vergetures", "Amélioration de la texture cutanée", "Régénération cellulaire"]
    },
    {
      name: "Vaccum Thérapie",
      description: "Traitement de la cellulite et raffermissement cutané",
      benefits: ["Réduction de la cellulite", "Raffermissement de la peau", "Drainage lymphatique", "Amélioration de la circulation"]
    },
    {
      name: "Lipocavitation",
      description: "Réduction des amas graisseux localisés",
      benefits: ["Destruction des cellules graisseuses", "Remodelage corporel", "Résultats visibles rapidement"]
    },
    {
      name: "Lipolaser",
      description: "Technologie laser pour affiner la silhouette",
      benefits: ["Ciblage précis des zones rebelles", "Non invasif", "Sans douleur"]
    },
    {
      name: "Radiofréquence",
      description: "Raffermissement et anti-âge de la peau",
      benefits: ["Stimulation du collagène", "Effet lifting naturel", "Peau plus ferme et tonique"]
    },
    {
      name: "Drainage Lymphatique",
      description: "Technique manuelle de détoxification",
      benefits: ["Élimination des toxines", "Réduction de la rétention d'eau", "Sensation de légèreté"]
    },
    {
      name: "Madérothérapie",
      description: "Massage avec outils en bois",
      benefits: ["Remodelage de la silhouette", "Amélioration de la circulation", "Détente profonde"]
    }
  ]
};

export const pricingPlans = [
  {
    type: "Avec engagement 6 mois",
    engagement: true,
    plans: [
      {
        sessions: 4,
        price: 135,
        perSession: 33.75
      },
      {
        sessions: 8,
        price: 200,
        perSession: 25
      }
    ]
  },
  {
    type: "Sans engagement",
    engagement: false,
    plans: [
      {
        sessions: 4,
        price: 155,
        perSession: 38.75
      },
      {
        sessions: 8,
        price: 280,
        perSession: 35
      }
    ]
  }
];

export const whyChooseUs = [
  {
    title: "Diagnostic Personnalisé",
    description: "Un bilan complet de votre corps et de vos objectifs pour créer un programme sur-mesure",
    icon: "clipboard"
  },
  {
    title: "Suivi Expert",
    description: "Accompagnement professionnel à chaque étape de votre transformation",
    icon: "userCheck"
  },
  {
    title: "Ambiance Privée",
    description: "Un espace intimiste et luxueux inspiré par la nature, uniquement pour vous",
    icon: "leaf"
  },
  {
    title: "Approche Globale",
    description: "Combinaison unique de renforcement musculaire et de soins esthétiques avancés",
    icon: "sparkles"
  }
];

export const journeySteps = [
  {
    step: 1,
    title: "Bilan Personnalisé",
    description: "Évaluation complète de votre silhouette, objectifs et besoins esthétiques"
  },
  {
    step: 2,
    title: "Programme Sur-Mesure",
    description: "Création d'un protocole adapté combinant EMS et soins ciblés"
  },
  {
    step: 3,
    title: "Séances & Suivi",
    description: "Accompagnement régulier avec ajustements selon votre progression"
  },
  {
    step: 4,
    title: "Résultats Visibles",
    description: "Transformation progressive de votre silhouette et regain de confiance"
  }
];
